import React, { useState } from "react";
import { Formik, Field } from "formik";
import OTPInput from "react-otp-input";
import close from "../../../assets/images/modal/close.svg";
import News_Left_Image from "../../../assets/images/News_Login_Left_Img.svg";
import "./CustomerLogin.scss";
import LabelWithTick from "../../../components/RequestModal/Adwords/helper";
import FormError from "../../../components/RequestModal/FormError";
import Phone, { isValidPhoneNumber } from "react-phone-number-input";
import { CountdownCircleTimer } from "react-countdown-circle-timer";

const CustomerLogin = ({ handleLoginModal }) => {
  const [showOtp, setShowOtp] = useState(false);
  const [otp, setOtp] = useState("");
  const [mobile, setMobile] = useState();
  const [actionButtonsDisabled, setActionButtonsDisabled] = useState(true);
  const handleSubmit = (values) => {
    setMobile(values.contact);
    setShowOtp(true);
  };

  const onResendClick = () => {
    setActionButtonsDisabled(true);
    // sendOtp({ mobile });
  };

  const onResendWaitComplete = () => {
    setActionButtonsDisabled(false);
  };

  return (
    <div className="customer_login_container">
      <div className="customer_login_left">
        <img src={News_Left_Image} alt="News" />
      </div>
      <div className="customer_login_right">
        <div className="modal__header news_login_header">
          <h1>{!showOtp ? `Login now` : "Enter OTP"} </h1>

          <img
            src={close}
            className="modal__close"
            alt="Close"
            onClick={() => {
              handleLoginModal(false);
            }}
          />
        </div>
        {!showOtp ? (
          <Formik
            initialValues={{ name: "", contact: "" }}
            onSubmit={(values) => {
              setShowOtp(true);
            }}
          >
            {({
              errors,
              touched,
              setFieldValue,
              values,
              setValues,
              handleChange,
            }) => {
              var formValidation =
                values?.name !== "" &&
                values?.contact !== "" &&
                isValidPhoneNumber(values.contact || "");
              return (
                <div className="herorequirementFormClass requirementContainer customer_form">
                  <div className="requirementForm">
                    <div className="formContent" style={{ maxHeight: "none" }}>
                      <div className="field customer_login_name">
                        <label htmlFor="name" className="labelWidth">
                          <LabelWithTick
                            label="Name"
                            withValidation={true}
                            style={{ color: " #676773" }}
                            isValid={values?.name && !errors.name}
                            containerClass={"flex"}
                            labelClass={"label"}
                            onChange={() => {}}
                          />
                          <Field
                            type="text"
                            id="name"
                            name="name"
                            placeholder="Enter name"
                          />
                        </label>
                        {touched.name && errors.name ? (
                          <FormError
                            error={errors.name}
                            errorClass="field-error"
                          />
                        ) : null}
                      </div>

                      <div className="field-contact field customer_login_contact">
                        <label htmlFor="contact" className="labelWidth">
                          <LabelWithTick
                            label="Mobile number"
                            withValidation={true}
                            style={{ color: " #676773" }}
                            isValid={
                              values?.contact &&
                              isValidPhoneNumber(values?.contact)
                            }
                            labelClass={"label"}
                          />

                          <div className="field-contact">
                            <Phone
                              onChange={(value) => {
                                setFieldValue("contact", value);
                              }}
                              value={values?.contact}
                              placeholder="Mobile number"
                              id="contact"
                              name="contact"
                              defaultCountry="IN"
                              type="tel"
                              international
                            />
                          </div>
                        </label>
                        {touched.contact && errors.contact ? (
                          <FormError
                            error={errors.contact}
                            errorClass="field-error"
                          />
                        ) : null}
                      </div>
                      <button
                        type="submit"
                        className="btn btn-primary buttonWidth
                        "
                        value="submit"
                        onClick={() => handleSubmit(values)}
                        disabled={
                          !(
                            formValidation &&
                            !Boolean(Object.keys(errors).length)
                          )
                        }
                      >
                        {"Get OTP"}
                      </button>
                    </div>
                  </div>
                </div>
              );
            }}
          </Formik>
        ) : (
          <>
            <div className="customer_otp_section">
              <p className="customer_otp_heading">
                Enter OTP sent to your mobile <span>{mobile}</span>
              </p>
              <OTPInput
                value={otp}
                onChange={setOtp}
                numInputs={4}
                inputStyle="customer_otp_input"
                containerStyle="otp_input_container"
                renderInput={(props) => <input {...props} />}
              />

              <div className="reset_button_container">
                <button
                  className="customer_reset_btn"
                  disabled={actionButtonsDisabled}
                  onClick={() => {
                    alert("OTP Resent!");
                    onResendClick();
                  }}
                >
                  Resend OTP
                </button>
                {actionButtonsDisabled ? (
                  <CountdownCircleTimer
                    colors={"#0067e2"}
                    isPlaying
                    duration={60}
                    size={28}
                    strokeWidth={3}
                    strokeLinecap={0}
                    trailStrokeWidth={0}
                    onComplete={onResendWaitComplete}
                  >
                    {({ remainingTime }) => (
                      <div className="flex relative justify-center items-center w-full h-full">
                        <div className="countdownBackground" />
                        <div className="countdownTime">{remainingTime}</div>
                      </div>
                    )}
                  </CountdownCircleTimer>
                ) : null}
              </div>
              <button
                type="submit"
                className="btn btn-primary buttonWidth
                get_OTP_button"
                value="submit"
                onClick={() => {
                  alert("OTP Verified. Logging in...");
                }}
                disabled={otp?.length !== 4}
              >
                Verify Number
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CustomerLogin;
